// Payment related labels
export const PAYMENT_OPTIONS = 'Payment options'
export const RENTAL_OPTIONS = 'Rental options'
export const DETAILS = 'Details'
export const CONVENIENCE_FEES = 'Convenience fees'
export const CONTINUE = 'Continue'
export const RCI_POINTS_CHART_BY_SUITE_TYPE = 'RCI points chart by suite type'
export const CONFIRM_DEPOSIT = 'Confirm Deposit'
export const VALUE_MUST_BE_GREATER = 'Value must be greater than or equal'
export const MAXIMUM_AMOUNT_EXCEEDED = 'The maximum amount to be deposited is'
export const PLEASE_ENTER_VALID_EMAIL = 'Please enter valid email address'
export const NO_PAYMENT_OPTIONS_AVAILABLE = 'No payment options available at this time.'
